//
// CSV code was adapted from:
// https://github.com/finnp/detect-csv/blob/master/index.js
//

const determineMost = (chunk: string, items: string[]) => {
    const itemCount = {};
    items.forEach(x => itemCount[x] = 0);
    let ignoreString = false;
    let maxValue = 0;
    let maxChar;
    let currValue;
    for (const ch of chunk) {
        if (ch === '"') ignoreString = !ignoreString;
        else if (!ignoreString && ch in itemCount) {
            currValue = ++itemCount[ch];
            if (currValue > maxValue) {
                maxValue = currValue;
                maxChar = ch;
            }
        }
    }
    return maxChar;
};

const isQuoted = (chunk: string) => {
    // is correctly quoted
    let nextQuote = false;
    if (chunk[0] !== '"') return false;
    if (chunk[chunk.length - 1] !== '"') return false;
    for (let i = 1; i < chunk.length - 1; i++) {
        if (chunk[i] === '"') nextQuote = !nextQuote;
        else if (nextQuote) return false;
    }
    return !nextQuote;
};

export interface CsvDetectOptions {
    delimiters?: string[];
    newlines?: string[];
}

const csv = (chunk: string, opts?: CsvDetectOptions) => {
    const delimiters = opts?.delimiters || [',', ';', '\t', '|'];
    const newlines = opts?.newlines || ['\n', '\r'];

    const lines = chunk.split(/[\n\r]+/g);

    const delimiter = determineMost(lines[0], delimiters);
    const newline = determineMost(chunk, newlines);

    if (!delimiter) {
        if (isQuoted(lines[0])) return { newline };
        return null;
    }

    return {
        delimiter,
        newline
    };
};

const json = (td: string) => {
    td = td.trim();
    if (td.startsWith('{') && td.endsWith('}')) return true;
    if (td.startsWith('[') && td.endsWith(']')) return true;
    return false;
};

const svg = (td: string) => {
    return td.trim().startsWith('<svg');
};

export const Detect = { csv, json, svg };
